export const administrationData = {
    my: {
        title: "အာမခံဆရာစနစ်",
        subtitle: "မဟာဝိဟာရ၏ အသက်သွေးကြော",
        introduction: {
            title: "အာမခံဆရာ၏ အရေးပါပုံ",
            content: "အာမခံဆရာသည် မဟာဝိဟာရကျောင်းတိုက်၏ အသက်သွေးကြောဟု ဆိုနိုင်၏၊ မဟာဝိဟာရတွင် စာချဘုန်းကြီး ၂၅ ပါးသာရှိသော်လည်း သံဃာကိုးရာကျော်ကို နိုင်နိုင်နင်းနင်း အုပ်ချုပ်နိုင်ခြင်းသည် အာမခံဆရာစနစ်ကြောင့်သာ ဖြစ်ပါ၏။"
        },
        sections: [
            {
                title: "အာမခံဆရာ ရွေးချယ်ခြင်း",
                content: "မဟာဝိဟာရကျောင်းတိုက်၌ သံဃာအသစ်ရောက်လာလျှင် အာမခံဆရာ ရှာရ၏၊ အသိရှိလျှင် အသိရဟန်းသာမဏေများကို အကူအညီတောင်းနိုင်၏၊ အသိမရှိလျှင်လည်း ကျောင်းတိုက်မှ သင့်တော်သည့် အာမခံဆရာ ရှာပေး၍ အပ်ပေးပါ၏။",
                note: "မဟာဝိဟာရကျောင်းတိုက်၌ ဝါဆိုပြီးသား ရဟန်းတော်များက အာမခံဆရာ လုပ်နိုင်၏။"
            },
            {
                title: "တာဝန်နှင့် ဝတ္တရားများ",
                content: "အာမခံဆရာသည် မိမိတာဝန်ယူနိုင်သလောက် လက်ခံခွင့်ရှိ၏၊ ၅-ပါးနိုင်လျှင် ၅-ပါး၊ ၁၀-ပါးနိုင်လျှင် ၁၀-ပါး လက်ခံခွင့်ရှိ၏၊",
                responsibilities: [
                    "ပညာရေး",
                    "ကျန်းမာရေး",
                    "ကိုယ်ကျင့်တရားကောင်းမွန်ရေး",
                    "စိတ်ထားကောင်းမွန်ရေး",
                    "နေ့စဉ် စာပြန်ခြင်း",
                    "အချိန်ပို သင်ကြားပေးခြင်း",
                    "ဩဝါဒပေး ဆုံးမခြင်း"
                ]
            },
            {
                title: "စနစ်တကျ လမ်းညွှန်မှု",
                content: "မိမိလက်ခံထားသော တပည့်သည် ပြောဆိုဆုံးမရခက်နေလျှင် အာမခံဆရာအဖြစ်မှ ရုတ်သိမ်းနိုင်၏၊ ထိုသို့ဖြစ်လျှင် အာမခံဆရာအသစ် ရှာဖွေရ၏။"
            },
            {
                title: "ပုံမှန် သွန်သင်ဆုံးမမှု",
                content: "သာသနာတော်၌ ဩဝါဒပေးလျက် ဆုံးမခြင်းသည် အလွန်အရေးကြီး၏",
                schedule: [
                    "အပတ်စဉ် အဖိတ်နေ့တိုင်း ည ၇- နာရီမှ ၈ - နာရီထိ ဩဝါဒပေးခြင်း",
                    "၈-ရက် ဥပုသ်နေ့များ၌ ပထမရွှေကျင်ဥပဒေများကို ဖတ်ကြားခြင်း",
                    "ဆရာတော်ကြီးများထံမှ ရံဖန်ရံခါ ဩဝါဒနာယူခြင်း",
                    "နေ့စဉ်ဘုရားရှိခိုးပြီး ဩဝါဒပေးခြင်း",
                    "သံဃာအသစ်များအတွက် သီးခြား နေ့စဉ် ဩဝါဒပေးခြင်း"
                ]
            }
        ],
        conclusion: {
            title: "အခြေခံမူ",
            content: "အာမခံဆရာမရှိလျှင် မဟာဝိဟာရ၌ နေထိုင်ခွင့် မရှိ"
        }
    },

    en: {
        title: "Guardian Teachers System",
        subtitle: "The Lifeline of Mahãvihãra",
        introduction: {
            title: "The Importance of Guardian Teachers",
            content: "The Guardian Teacher system is the lifeline of Mahãvihãra Monastery. Despite having only 25 teaching monks, we successfully manage over 900 resident monks through this effective system."
        },
        sections: [
            {
                title: "Guardian Teacher Assignment",
                content: "When new monks arrive at Mahãvihãra, they must find a Guardian Teacher. Those who know existing monks can request assistance through them, while others are matched with suitable Guardian Teachers by the monastery administration.",
                note: "Only monks who have completed at least one Buddhist Lent at Mahãvihãra can serve as Guardian Teachers."
            },
            {
                title: "Responsibilities and Duties",
                content: "Guardian Teachers can accept students based on their capacity to mentor, whether it's 5 or 10 disciples. They take full responsibility for their students':",
                responsibilities: [
                    "Academic progress",
                    "Health and well-being",
                    "Moral conduct",
                    "Mental development",
                    "Daily scripture recitation",
                    "Additional tutoring when needed",
                    "Spiritual guidance and counseling"
                ]
            },
            {
                title: "Systematic Guidance",
                content: "This system allows for personalized attention to each student's development without requiring direct oversight from the main teaching monks. If a Guardian Teacher finds it difficult to guide a particular student, they may withdraw from their role, necessitating the assignment of a new Guardian Teacher."
            },
            {
                title: "Regular Instruction",
                content: "Following the Buddha's emphasis on the importance of instruction (Ovāda), Mahãvihãra maintains a structured system of guidance:",
                schedule: [
                    "Weekly Ovāda sessions every Friday from 7-8 PM",
                    "Recitation of First Shwegyin Rules on Uposatha days",
                    "Occasional teachings from senior monks",
                    "Daily guidance after morning prayers",
                    "Special instruction sessions for new residents"
                ]
            }
        ],
        conclusion: {
            title: "Core Principle",
            content: "The fundamental rule at Mahãvihãra states: 'No one may reside at Mahãvihãra without a Guardian Teacher.' This system ensures proper guidance and maintains the high standards of monastic education and discipline."
        }
    }
};